import installRegistry from './install_registry';
import jobPageComponents from './job_page_components';

installRegistry(jobPageComponents, 'job_new');
